module.exports = __webpack_public_path__ + "img/budget-simple.0dce6f11.svg";